import { Button, Icon, Menu, MenuPlacement, Tooltip, TooltipPlacement, YStack } from '@shinetools/lumen-react'
import { EllipsisIcon } from 'lucide-react'
import { Fragment, ReactElement } from 'react'

import { BillsTableRow } from '../../types/billsTableRow'
import { useBillsTableActions } from './hooks/useBillsTableActions'

interface BillsTableActionsCellProps {
  row: BillsTableRow
}

/**
 * @todo Handle localization
 * @see https://linear.app/shine-co/issue/EXP-357/web-add-localization
 */
export const BillsTableActionsCell = ({ row }: BillsTableActionsCellProps): ReactElement | null => {
  const actions = useBillsTableActions(row)

  if (!actions.length) {
    return null
  }

  return (
    <>
      <Menu
        placement={MenuPlacement['bottom-end']}
        aria-label="Actions"
        trigger={<Button variant="text" size="small" icon={<Icon icon={EllipsisIcon} />} aria-label="Actions" />}
        size="medium"
      >
        {actions.map(({ type, label, icon, onClick, disabled, disabledReason }) => {
          const item = (
            <Menu.Item key={type} label={label} icon={<Icon icon={icon} />} onClick={onClick} disabled={disabled} />
          )

          if (!disabled || !disabledReason) {
            return item
          }

          // Menu.Item doesn't forward refs, so the tooltip needs a wrapping trigger element
          return (
            <Tooltip key={type} label={disabledReason} placement={TooltipPlacement.left}>
              <YStack>{item}</YStack>
            </Tooltip>
          )
        })}
      </Menu>

      {actions.map(({ type, confirmationModal }) =>
        confirmationModal ? <Fragment key={type}>{confirmationModal}</Fragment> : null,
      )}
    </>
  )
}
